import React, { useState, useEffect, useRef } from 'react';
import {useDispatch, useSelector} from "react-redux";
import {doCompaniesSearch, selectIsLoading} from "../../../../store/reducers/companiesReducer";
import {useLocation} from "react-router-dom";
import LoadingSpinner from "../../../common/LoadingSpinner";
import Tooltip from '../../tooltip/Tooltip';
import Select from 'react-select';
import {countryList, recaptchaSiteKey} from "../../../../constants";

function Search() {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectIsLoading);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const s = params?.get('s');
    const c = params?.get('c');
    const [searchString, setSearchString] = useState(s || '');
    const [countryCode, setCountryCode] = useState(c || 'NO');
    const [openTooltip, setOpenTooltip] = useState(false);
    const [tooltipClass, setTooltipClass] = useState("more_info-inline closed");
    const span = useRef();
    const countryArray = countryList.map(country => ({ value: country.countryCode, label: country.name }));

    const isSearchEnabled = (isLoading, searchString) => {
        return !isLoading && searchString.length >= 2;
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []); // eslint-disable-line

    const onCountrySelect = (selection) => {
        setCountryCode(selection.value);

        if (isSearchEnabled(isLoading, searchString)) {
            doSearch(searchString, selection.value);
        }
    }

    const handleClick = e => {
        if (span?.current?.contains(e.target)) {
            setOpenTooltip(true)
            setTooltipClass("more_info-inline active")
            return;
        }
        setOpenTooltip(false)
        setTooltipClass("more_info-inline closed")        
    };

    useEffect(async () => {
        if (searchString) {
            _doSearch().then()
        }
    }, []) // eslint-disable-line

    const submit = async (e) => {
        e.preventDefault();

        await _doSearch();
    }

    const _doSearch = async (count = 0) => {
        // Don't try more than five times
        if (count >= 10) {
            return
        }

        if (window.grecaptcha?.execute) {
            try {
                const token = await window.grecaptcha.execute(recaptchaSiteKey, {action: 'search'})
                doSearch(searchString, countryCode, token);
            } catch (error) {
                setTimeout(() => _doSearch(count + 1), 250);
            }
        } else {
            // Try again in 200 ms
            setTimeout(() => _doSearch(count + 1), 250);
        }
    }

    const doSearch = (searchString, countryCode, recaptchaToken) => {
        dispatch(doCompaniesSearch({searchString: searchString, countryCode: countryCode, recaptchaToken: recaptchaToken}));
    }

    return (
        <form className="search-form" action="/" onSubmit={submit}>
            <div className="search-form-input">
                <div className="search_tooltip_container">
                    <input type="search"
                        placeholder="Search for company.."
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                        disabled={isLoading}
                        autoFocus={true}
                    />
                    <span 
                        className={tooltipClass} 
                        ref={span}
                        onClick={handleClick}>                  
                            {openTooltip && (
                                <Tooltip title="" text="Type company name or Org No in the search field to find your company"/>
                            )}
                    </span>
                </div>
                <div className="country-search_container">
                    <Select
                        className="react-select"
                        name="countryName"
                        defaultValue={ {label: countryList.find(country => countryCode === country.countryCode).name, value: countryCode } }
                        options={countryArray}
                        onChange={onCountrySelect}
                        searchable={false}
                        classNamePrefix="react-select"
                    />
                </div>
                <div className="search_button">
                    <button disabled={!isSearchEnabled(isLoading, searchString)}>{isLoading ? <LoadingSpinner light={true} small={true}/> : "Search"}</button>
                </div>
            </div>
        </form>
    );
}

Search.propTypes = {};

export default Search;
